import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "gatsby";
import { ApiUrl } from "../../../utils/url-provider";
import { FiArrowRightCircle } from "react-icons/fi";

const WaitTimeWidget = () => {
  let gate1A = "0-5 minutes";
  let gate1B = "0-5 minutes";
  const [data, setData] = useState([]);
  const [time, setTime] = useState(null);
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    const now = new Date();
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    setLastUpdated(now.toLocaleString("en-IN", options));
  }, []);

  useEffect(() => {
    const location = "wait-time?places=T3%20Entrance";
    axios
      .get(ApiUrl(location))
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  return (
    <div className="w-full bg-[#537696] rounded-lg xl:w-[85%] mx-auto flex flex-col xl:flex-row gap-[2vw] xl:gap-0 py-[2vh] items-center xl:items-center xl:justify-around ">
      <div className="lg:flex items-center justify-center gap-[2vw] w-full xl:w-auto mb-[2vw] xl:mb-0">
        {/* Live + Mobile Dot */}
        <div className="flex justify-center items-center lg:gap-x-0 gap-x-[3vw]">
          <div className="text-[#FFFFFF] text-[7vw] xl:text-[2vw] font-semibold">
            LIVE
          </div>
          <div className="relative flex lg:hidden items-center justify-center mt-[1vw]">
            {/* Outer ripple */}
            <span className="absolute w-[4vw] h-[4vw] rounded-full bg-red-500 opacity-75 animate-ripple"></span>
            {/* Solid dot */}
            <span className="relative w-[3vw] h-[3vw] rounded-full bg-red-600"></span>
          </div>
        </div>

        {/* Desktop Dot + wait time */}
        <div className="flex font-redhatMedium justify-center items-center gap-x-[1vw]">
          {/* Dot with ripple */}
          <div className="relative lg:flex hidden items-center justify-center mt-[0.3vw]">
            {/* Outer ripple */}
            <span className="absolute w-[1vw] h-[1vw] rounded-full bg-red-500 opacity-75 animate-ripple"></span>
            {/* Solid dot */}
            <span className="relative w-[0.6vw] h-[0.6vw] rounded-full bg-red-600"></span>
          </div>

          {/* Text */}
          <Link to="/wait-time">
            {/* <div className="text-[#FFA500] text-[7vw] xl:text-[2vw] font-bold">
              Wait Time
            </div> */}
            <div className="text-white text-[5vw] xl:text-[1.4vw] font-bold py-1 rounded-md">
              Wait Time
            </div>
          </Link>
        </div>

        <div className="hidden xl:block text-white text-[5vw] xl:text-[1.4vw] font-redhatMedium">
          |
        </div>

        {/* Gate */}
        <div className="flex flex-col xl:flex-row items-center w-full xl:w-auto justify-center xl:justify-start gap-[1vw] text-[#fff] text-[5vw] xl:text-[1.4vw] font-redhatMedium mb-[1vw] xl:mb-0">
          <div>
            Gate 1A :{" "}
            {data?.waiting_time?.[0]?.waiting_time
              ? data?.waiting_time?.[0]?.waiting_time
              : gate1A}
          </div>

          <div className="hidden xl:block">|</div>
          <div>
            Gate 1B :{" "}
            {data?.waiting_time?.[1]?.waiting_time
              ? data?.waiting_time?.[1]?.waiting_time
              : gate1B}
          </div>
        </div>

        {/* Last Update */}
        <div className="w-full xl:w-auto text-center xl:text-right text-[#fff] text-[4vw] xl:text-[1vw] mt-[1vw] xl:mt-0">
          Last Update at : {lastUpdated}
        </div>

        <Link to="/wait-time" aria-label="Check wait times">
          <div className="flex justify-center">
            <div className="inline-block m-auto bg-primary py-2 px-5 rounded-lg mt-[3vw] lg:mt-0">
              <FiArrowRightCircle className="text-white text-[7vw] lg:text-[2vw] font-redhatBold" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default WaitTimeWidget;
